/* ARMAX UNITED theme scripts — no dependencies */
(function () {
  'use strict';

  /* ---- theme toggle ---- */
  function setTheme(t) {
    document.documentElement.setAttribute('data-theme', t);
    var toggle = document.querySelector('[data-theme-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-label', 'Switch to ' + (t === 'dark' ? 'light' : 'dark') + ' mode');
      var icon = toggle.querySelector('.icon-swap');
      if (icon) {
        icon.innerHTML =
          t === 'dark'
            ? '<svg width="20" height="20" aria-hidden="true"><use href="#icon-sun"/></svg>'
            : '<svg width="20" height="20" aria-hidden="true"><use href="#icon-moon"/></svg>';
      }
    }
  }
  setTheme(window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark');

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-theme-toggle]');
    if (t) {
      setTheme(document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark');
    }
  });

  /* ---- mobile nav ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.nav-toggle');
    if (toggle) {
      var nav = document.querySelector('.mobile-nav');
      if (!nav) return;
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
  });

  /* ---- scroll reveal ---- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
    );
    els.forEach(function (el) { io.observe(el); });
  }
  initReveals(document);

  /* ---- product gallery thumbs ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.gallery-thumb');
    if (!thumb) return;
    var gallery = thumb.closest('.product-gallery');
    var main = gallery && gallery.querySelector('.gallery-main img');
    if (main && thumb.dataset.src) {
      main.src = thumb.dataset.src;
      if (thumb.dataset.srcset) {
        main.srcset = thumb.dataset.srcset;
      } else {
        main.removeAttribute('srcset');
      }
      gallery.querySelectorAll('.gallery-thumb').forEach(function (el) {
        el.setAttribute('aria-current', el === thumb ? 'true' : 'false');
      });
    }
  });

  /* ---- quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var step = btn.dataset.qty === 'up' ? 1 : -1;
    var next = (parseInt(input.value, 10) || 1) + step;
    input.value = Math.max(parseInt(input.min, 10) || 0, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- cart line auto-update on quantity change ---- */
  document.querySelectorAll('.cart-line-qty input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = document.getElementById('CartForm');
      if (form) form.submit();
    });
  });

  /* ---- nav dropdowns (details/summary) ---- */
  /* close open menus when clicking elsewhere, one open at a time */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.nav-drop[open], details.mobile-drop-details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.open || !d.classList) return;
    if (d.classList.contains('nav-drop') || d.classList.contains('mobile-drop-details')) {
      document.querySelectorAll('details.nav-drop[open], details.mobile-drop-details[open]').forEach(function (o) {
        if (o !== d) o.removeAttribute('open');
      });
    }
  }, true);
  /* open on hover on pointer devices (desktop) */
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  document.addEventListener('mouseover', function (e) {
    if (!canHover) return;
    var d = e.target.closest('details.nav-drop');
    if (d) d.setAttribute('open', '');
  });
  document.addEventListener('mouseout', function (e) {
    if (!canHover) return;
    var d = e.target.closest('details.nav-drop');
    if (d && !d.contains(e.relatedTarget)) d.removeAttribute('open');
  });
  /* a pointer click on an already-hover-open summary should not close it;
     keyboard clicks (detail 0) still toggle normally */
  document.addEventListener('click', function (e) {
    if (!canHover || !e.detail) return;
    var summary = e.target.closest('summary.nav-drop-toggle');
    if (!summary) return;
    var d = summary.parentElement;
    if (d && d.hasAttribute('open')) e.preventDefault();
  }, true);

  /* ---- shopify theme editor ---- */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initReveals(e.target);
    });
  }
})();
